var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      staticClass: "modal",
      attrs: {
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _vm._v(" Выдать" + _vm._s(!_vm.hasType ? " ТМЦ" : "") + " "),
              _vm.hasType
                ? _c("span", { staticClass: "type-name" }, [
                    _vm._v(" " + _vm._s(_vm.passedType.name) + " "),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      !_vm.isInitialized && _vm.busy
        ? _c("Loader", {
            attrs: {
              label: "Данные загружаются",
              height: !_vm.hasType ? 405 : 327,
              active: true,
            },
          })
        : [
            _vm.hasType && !_vm.items.length
              ? [
                  _c("div", { staticClass: "notice" }, [
                    _vm._v(
                      " Для данного типа нет ТМЦ. Обратитесь к администратору. "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c("Button", {
                        attrs: { label: "Закрыть" },
                        on: { click: _vm.close },
                      }),
                    ],
                    1
                  ),
                ]
              : _c("vee-observer", {
                  attrs: { slim: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, errors }) {
                        return [
                          _c(
                            "form",
                            {
                              staticClass: "form",
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return handleSubmit(_vm.submit)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "inputs" },
                                [
                                  !_vm.hasType
                                    ? _c(
                                        "vee-provider",
                                        {
                                          attrs: {
                                            vid: "type",
                                            rules: "required",
                                            slim: "",
                                          },
                                        },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              "floating-label":
                                                "Категория/подкатегория/тип ТМЦ",
                                              type: "select",
                                              items: _vm.types,
                                              error: errors.type,
                                              "with-categorized": true,
                                              "required-mark": true,
                                              clearable: true,
                                              searchable: true,
                                              "actually-normal-error-messages": true,
                                            },
                                            model: {
                                              value: _vm.form.type,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "type", $$v)
                                              },
                                              expression: "form.type",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "vee-provider",
                                    {
                                      attrs: {
                                        vid: "item",
                                        rules: "required",
                                        slim: "",
                                      },
                                    },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          "floating-label": "ТМЦ",
                                          type: "select",
                                          items: _vm.items,
                                          error: errors.item,
                                          disabled: _vm.busy,
                                          "required-mark": true,
                                          clearable: true,
                                          searchable: true,
                                          "actually-normal-error-messages": true,
                                        },
                                        model: {
                                          value: _vm.form.item,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "item", $$v)
                                          },
                                          expression: "form.item",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "inputs__row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "date-input" },
                                        [
                                          _c(
                                            "vee-provider",
                                            {
                                              attrs: {
                                                vid: "date",
                                                rules: "required|date",
                                                slim: "",
                                              },
                                            },
                                            [
                                              _c("Input", {
                                                ref: "calendar",
                                                attrs: {
                                                  label: "Дата выдачи",
                                                  placeholder: "00.00.0000",
                                                  format: "DD.MM.YYYY, dddd",
                                                  type: "date",
                                                  icon: "calendar",
                                                  error: errors.date,
                                                  editable: true,
                                                  "icon-right": true,
                                                  "required-mark": true,
                                                  "actually-normal-error-messages": true,
                                                },
                                                model: {
                                                  value: _vm.form.issueDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "issueDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.issueDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("Input", {
                                        attrs: {
                                          "floating-label": "Кто выдал",
                                          type: "select",
                                          items: _vm.employees,
                                          searchable: true,
                                          clearable: true,
                                        },
                                        model: {
                                          value: _vm.form.issuer,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "issuer", $$v)
                                          },
                                          expression: "form.issuer",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vee-provider",
                                    {
                                      attrs: {
                                        vid: "comment",
                                        rules: "max:500",
                                        slim: "",
                                      },
                                    },
                                    [
                                      _c("InputOld", {
                                        attrs: {
                                          "floating-label": "Комментарий",
                                          type: "textarea",
                                          "max-length": "500",
                                          clearable: true,
                                        },
                                        model: {
                                          value: _vm.form.comment,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "comment", $$v)
                                          },
                                          expression: "form.comment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("FileLoader", {
                                    ref: "fileLoader",
                                    attrs: {
                                      actions: "loadFiles,preview",
                                      format: "all",
                                      limit: 10,
                                    },
                                    model: {
                                      value: _vm.form.files,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "files", $$v)
                                      },
                                      expression: "form.files",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "actions" },
                                [
                                  _c("Button", {
                                    attrs: { label: "Отменить" },
                                    on: { click: _vm.close },
                                  }),
                                  _c("Button", {
                                    attrs: {
                                      label: "Выдать",
                                      color: "primary",
                                      type: "submit",
                                      disabled: _vm.busy,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }